var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.loading)?_c('loader',{staticClass:"center-loader"}):_c('div',{staticClass:"contant"},[_c('breadcrumbs',{staticClass:"mb-4",attrs:{"links":[
				{ name: _vm.$t('breadcrumbs.home'), path: '/' },
				{ name: _vm.$t('breadcrumbs.albums'), path: '/', active: true },
			]}}),_c('div',{staticClass:"row"},_vm._l((_vm.albums),function(album,i){return _c('div',{key:i,staticClass:"col-lg-4 col-md-6 col-12 mb-4 news-card"},[_c('div',{staticClass:"p-2"},[_c('album-card',{attrs:{"album":album}})],1)])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }